<div *ngIf="visible">
  <div class="tokens-header">
    <h3 class="title-margin-top">{{ 'personal_access_token_title' | translate }}</h3>
    <div class="btn-add" *ngIf="!userId">
      <button mat-mini-fab type="button" (click)="create()" [title]="'personal_access_token_btn_create' | translate">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  <p class="tokens-help">
    {{ (userId ? 'personal_access_token_help_admin' : 'personal_access_token_help') | translate }}
    {{ 'personal_access_token_docs_contact' | translate }}
    <a [href]="'mailto:' + contactMail">{{ contactMail }}</a>
  </p>
  <mat-card>
    <div *ngIf="tokens.length === 0" class="tokens-empty">{{ 'personal_access_token_empty' | translate }}</div>
    <div *ngIf="tokens.length > 0">
      <div class="row header text-bold">
        <div class="col-2">{{ 'common_field_label' | translate }}</div>
        <div class="col-2">{{ 'personal_access_token_col_role' | translate }}</div>
        <div class="col-2">{{ 'personal_access_token_col_scopes' | translate }}</div>
        <div class="col-1">{{ 'personal_access_token_col_created' | translate }}</div>
        <div class="col-1">{{ 'personal_access_token_col_last_used' | translate }}</div>
        <div class="col-1">{{ 'personal_access_token_col_expires' | translate }}</div>
        <div class="col-2">{{ 'personal_access_token_col_status' | translate }}</div>
        <div class="col-1 text-center">{{ 'personal_access_token_col_revoke' | translate }}</div>
      </div>
      <div class="row" [ngClass]="{ backgroundColor: index % 2 == 0 }" *ngFor="let token of tokens; let index = index">
        <div class="col-2">
          {{ token.name }}
          <div class="token-id">{{ token.environment }} · {{ token.publicId }}</div>
        </div>
        <div class="col-2">{{ token.profileCode }} - {{ token.perimeterName }}</div>
        <div class="col-2">
          <div *ngFor="let scope of token.scopes" [title]="'personal_access_token_scope_' + scope.replace(':', '_') | translate">
            <code>{{ scope }}</code>
          </div>
        </div>
        <div class="col-1">{{ utc(token.createDate) | date: 'dd/MM/yy' }}</div>
        <div class="col-1">{{ token.lastUsedDate ? (utc(token.lastUsedDate) | date: 'dd/MM/yy') : '-' }}</div>
        <div class="col-1">{{ token.expireDate ? (utc(token.expireDate) | date: 'dd/MM/yy') : ('personal_access_token_never' | translate) }}</div>
        <div class="col-2">{{ 'personal_access_token_status_' + status(token) | translate }}</div>
        <div class="col-1 text-center">
          <mat-icon *ngIf="status(token) === 'active'" class="icon-color" (click)="revoke(token)" [title]="'personal_access_token_btn_revoke' | translate">block</mat-icon>
        </div>
      </div>
    </div>
  </mat-card>
</div>
